import { render, staticRenderFns } from "./location.vue?vue&type=template&id=153cd52c&scoped=true"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"
import style0 from "./location.vue?vue&type=style&index=0&id=153cd52c&prod&lang=scss"
import style1 from "./location.vue?vue&type=style&index=1&id=153cd52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153cd52c",
  null
  
)

export default component.exports